<template>
  <div>
    <header class="navbar-fixed-top shadow-on-scroll">
      <div class="header-top-color">
        <div class="container my-custom-container">
          <div class="row">
            <div class="col-md-12 lang-bar">
              <div
                class="col-md-8 col-sm-12 col-xs-12 clear-padding"
                style="display: flex;align-items: center; justify-content: flex-start;"
              >
                <div style="float: right">
                  <a class="showOnSearch">
                    <form action="https://azcloud.az/ru/view/search/">
                      <input type="text" class="form-control" name="keyword" />
                    </form>
                    <span class="search-btn">Axtarışı dayandır</span>
                  </a>
                  <a class="search-btn">
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </a>

                  <a
                    href=""
                    @click="changeLanguage($event, 'az')"
                    title="Azərbaycanca"
                  >AZ</a>
                  <a href="" @click="changeLanguage($event, 'en')" title="English">EN</a>
                  <a href="" @click="changeLanguage($event, 'ru')" title="Русский" class="active">RU</a>
                </div>
              </div>
              <div class="col-md-4 col-sm-12 col-xs-12 top-logo-standarts clear-padding">
                <a href="https://enterprise.azcloud.az/ru/view/about/#certificate-rows">
                  <img
                    class="img-responsive"
                    src="/frontend/images/tier3-facility.svg"
                  />
                </a>

                <!--                <a href="/-->
                <!--/view/about/#certificate-rows"><img class="img-responsive" src="/frontend/images/tier3-design.svg"></a>-->

                <a href="https://enterprise.azcloud.az/ru/view/about/#iso-row">
                  <img
                    class="img-responsive"
                    src="/frontend/images/iso-20000.svg"
                  />
                </a>

                <a href="https://enterprise.azcloud.az/ru/view/about/#iso-row">
                  <img
                    class="img-responsive"
                    src="/frontend/images/iso-27001.svg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header-bottom-color">
        <div class="container">
          <div class="row menu-bar">
            <div class="col-lg-6 col-sm-6 logo-row">
              <div class="logo-holder pull-left">
                <a href="https://azcloud.az/ru/">
                  <img
                    class
                    src="/frontend/images/Azcloud_H_SVG.SVG"
                    alt
                    height="40px"
                  />
                </a>
              </div>
              <div class="m-menu-icon pull-right">
                <i class="fa fa-bars" aria-hidden="true"></i>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 menu-row">
              <div class="menu-holder flex-container my-custom-container jst-right">
                <ul class="flex-container my-custom-container">
                  <li class="has-dropdown">
                    <a href="https://enterprise.azcloud.az/ru/view/about/">О нас</a>
                  </li>
                  <li class="has-dropdown">
                    <a href="https://enterprise.azcloud.az/ru/view/services/">Услуги</a>
                  </li>
                  <li class="has-dropdown">
                    <a href="https://enterprise.azcloud.az/ru/view/partnership">Партнерство</a>
                  </li>
                  <li class="has-dropdown">
                    <a href="https://enterprise.azcloud.az/ru/view/contact/">Контакты</a>
                  </li>
                  <li class="mobile-search">
                    <form action="https://azcloud.az/ru/view/search/">
                      <input
                        type="text"
                        class="form-control"
                        name="keyword"
                        placeholder="Axtarış..."
                      />
                    </form>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section class="page-head">
      <div class="container">
        <div class="row page-blue-head">
          <div class="col-md-8">
            <p>ВИРТУАЛЬНАЯ IP-ТЕЛЕФОНИЯ</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  methods: {
    changeLanguage(event, lan) {
      this.$router.push("/"+lan);
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/RU/Header.vue